import { Outlet } from "react-router-dom";
import Sidebar from "../Components/Menu/Sidebar";

const SiteLayout = function () {
  return (
    <div className="bg-background min-h-screen">
      <div className="md:ml-[72px]">
        <Sidebar />
        <div className="pb-16 md:pb-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SiteLayout;
